import React, { FC, useEffect } from 'react';
// components
import Notification from '../../atoms/notification';
import Footer from '../../organisms/footer';
// types
import { footerCancelButtonVariantType, userType } from '../../../types/types';
// hooks
import { usePatientZoomWarningNotification } from '../../../hooks/usePatientZoomWarningNotification';
// styles
import './index.scss';

interface TestTemplateProps {
  children: React.ReactNode;
  height: boolean;
  handleSubmit?: () => void;
  handleCancel?: () => void;
  disabled?: boolean;
  submitHidden?: boolean;
  submitLabel?: string;
  isConnectStatusShown?: boolean;
  isUserConnected?: boolean;
  customUserType?: userType;
  isSubmitDecline?: boolean;
  submitButtonVariant?: footerCancelButtonVariantType;
  className?: string;
}

const TestTemplate: FC<TestTemplateProps> = ({
  children,
  submitHidden,
  handleSubmit,
  handleCancel,
  disabled,
  submitLabel,
  isConnectStatusShown,
  isUserConnected,
  customUserType,
  isSubmitDecline,
  submitButtonVariant,
  height,
  className,
}: TestTemplateProps) => {
  const path = window.location.pathname;

  usePatientZoomWarningNotification(path);

  // iOS zoom disabling
  useEffect(() => {
    const pinchZoom = (event: any) => {
      if (event.scale !== 1) {
        event.preventDefault();
      }
    };

    let lastTouchEnd = 0;

    const doubleTapZoom = (event: any) => {
      const now = new Date().getTime();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    };

    document.addEventListener('touchmove', pinchZoom, { passive: false });
    document.addEventListener('touchend', doubleTapZoom, { passive: false });

    return () => {
      document.removeEventListener('touchmove', pinchZoom);
      document.removeEventListener('touchend', doubleTapZoom);
    };
  }, []);

  return (
    <>
      <Notification />
      <div className={`content content_test${className ? ` ${className.trim()}` : ''}`}>
        <div className="content__inner">{children}</div>
        <Footer
          submitHidden={submitHidden}
          handleSubmit={handleSubmit}
          handleCancel={handleCancel}
          disabled={disabled}
          submitLabel={submitLabel}
          isConnectStatusShown={isConnectStatusShown}
          isUserConnected={isUserConnected}
          userType={customUserType}
          isSubmitDecline={isSubmitDecline}
          submitButtonVariant={submitButtonVariant}
          height={height}
        />
      </div>
    </>
  );
};

export default TestTemplate;
